import script from "./TgSearch.vue?vue&type=script&lang=ts&setup=true"
export * from "./TgSearch.vue?vue&type=script&lang=ts&setup=true"

import "./TgSearch.vue?vue&type=style&index=0&id=40a6d710&scoped=true&lang=css"

import exportComponent from "/Users/ra1to/Desktop/web_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40a6d710"]])

export default __exports__